// TODO: Consider generating these types from swagger.json using tools like NSwag

export type Policy = {
    roles: Array<Role>,
    permissions: Array<Permission>,
    firstName: string,
    lastName?: string,
}

export enum Permission {
    Impersonate = 'IMPERSONATE',
    EBR = 'INSEBR',
    ProgramHub = 'PROGRAMHUB'
};

export enum Role {
    CorporateAccountManager = 'Corporate Account Manager',
    Customer = 'Customer'
}
